import React from 'react';
import { GameType } from '../../types/games';
import { TicTacToe } from './TicTacToe';
import { RockPaperScissors } from './RockPaperScissors';
import { Connect4 } from './Connect4';
import { Checkers } from './Checkers';
import { CastleDefense } from './CastleDefense';
import { Chess } from './Chess';

interface GameBoardProps {
  type: GameType;
  difficulty: 'easy' | 'medium' | 'hard';
  onWin: () => void;
  onLose: () => void;
  onDraw: () => void;
  isPlaying: boolean;
}

export function GameBoard({ type, difficulty, onWin, onLose, onDraw, isPlaying }: GameBoardProps) {
  const games = {
    ticTacToe: TicTacToe,
    rockPaperScissors: RockPaperScissors,
    connect4: Connect4,
    checkers: Checkers,
    castleDefense: CastleDefense,
    chess: Chess
  };

  const GameComponent = games[type];

  if (!isPlaying) {
    return (
      <div className="bg-gray-900 p-6 rounded-xl shadow-lg text-center">
        <p className="text-yellow-400 text-xl font-serif mb-4">Place your bet to begin</p>
        <p className="text-gray-400">Win to double your coins!</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-900 p-6 rounded-xl shadow-lg">
      <GameComponent 
        difficulty={difficulty} 
        onWin={onWin}
        onLose={onLose}
        onDraw={onDraw}
      />
    </div>
  );
}